export class BreadcrumbEntry {
  constructor(public id: string, public label: string, public path: any[] = [], public fakePath: BreadcrumbEntry[] = [],
              public icon: string = '', public base: boolean = false, public hidden: boolean = false, public queryParams: object = null) {
  }
}
